export default "__VITE_ASSET__Cl98JXQ3__"